import { AttractionCategoriesList } from '@/components/attraction-categories';
import {
  attractionCategoryCrudConfig,
  type AttractionCategory,
} from '@/config/objects/attraction-categories';
import { useAttractionTypeContext } from '@/pages/attraction-types/useAttractionTypeContext';
import { Loading, useApiClient, type CrudConfig } from '@startupquickstart/frontend';
import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { toast } from '@startupquickstart/frontend';

export function AttractionTypeCategoriesTab() {
  const { id } = useParams<{ id: string }>();
  const { attractionType, isLoading } = useAttractionTypeContext();
  const apiClient = useApiClient();

  const attractionTypeCategoriesConfig: CrudConfig<AttractionCategory> = useMemo(
    () => ({
      ...attractionCategoryCrudConfig,
      entityName: 'Attraction Category',
      entityNamePlural: 'Attraction Categories',
      endpoints: {
        ...attractionCategoryCrudConfig.endpoints,
        list: `/attraction-types/${id}/categories`,
        delete: (categoryId: string) => `/attraction-types/${id}/categories/${categoryId}`,
      },
      listView: {
        ...attractionCategoryCrudConfig.listView,
        actions: {
          add: {
            enabled: true,
            endpoint: '/attraction-categories',
            where: attractionType
              ? {
                  types: {
                    none: {
                      attractionTypeId: attractionType.id,
                    },
                  },
                }
              : undefined,
            onAdd: async (category: AttractionCategory) => {
              await apiClient.post(`/attraction-types/${id}/categories`, {
                attractionCategoryId: category.id,
              });
              toast.success('Category added to attraction type');
            },
          },
          view: {
            enabled: true,
          },
          remove: {
            enabled: true,
            onRemove: async (category: AttractionCategory) => {
              await apiClient.delete(`/attraction-types/${id}/categories/${category.id}`);
              toast.success('Category removed from attraction type');
            },
          },
        },
      },
    }),
    [attractionType, id, apiClient],
  );

  if (isLoading) {
    return (
      <div className="flex justify-center py-12">
        <Loading />
      </div>
    );
  }

  return (
    <AttractionCategoriesList
      config={attractionTypeCategoriesConfig}
      className="p-0"
      baseUrl="/attraction-categories"
    />
  );
}
